export default __webpack_public_path__ + "static/media/piratengp24_light.96aa6c4c.png";